/* eslint-disable no-unused-expressions */
import { Link, useLocation } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { removeNodeAtPath, changeNodeAtPath } from '@nosferatu500/react-sortable-tree';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';
import mongoDBObjectIDGenerator from 'utils/mongodb-objectid-generator';
import CreateNewFolderIcon from '@mui/icons-material/InsertDriveFileOutlined';

export const getNodeKey = ({ node }) => node.id;

// Current type slug from the URL (/:client/:type/...). The sidebar renders
// above the :type route, so useParams() can't see it here.
export const useCurrentTypeSlug = () => {
    const { pathname } = useLocation();
    return pathname.split('/')[2] || '';
};

// Leaf link that knows whether it points at the currently open type.
const NavTreeLink = ({ node, onClick }) => {
    const currentType = useCurrentTypeSlug();
    const isActive = !!node.id && node.id === currentType;

    return (
        <Link
            to={node.id}
            onClick={onClick}
            title={node.title}
            aria-current={isActive ? 'page' : undefined}
            className={isActive ? 'nav_tree_link nav_tree_link--active' : 'nav_tree_link'}
        >
            {node.title}
        </Link>
    );
};

NavTreeLink.propTypes = {
    node: PropTypes.shape({ id: PropTypes.string, title: PropTypes.string }).isRequired,
    onClick: PropTypes.func
};

//  In case Tree is Empty
export const emptyTree = () => [
    {
        title: 'Configuration', // Name of folder/File
        edit: false, // For Addiing Input box on Tree Node
        isDirectory: true, // Check for Folder or File
        id: mongoDBObjectIDGenerator(), // ID
        expanded: false, // For Expanded the Folder
        // removeFileButton: true, // To Remove  File button
        removeCancelButton: true, // To Deleting Empty Tree Node
        children: [] // in Case Noode has child
    }
];

// To Change any Props on Tree Node (Folder/File)
export const changeNode = (navTreeData, rowInfo, key, value) => {
    const data = changeNodeAtPath({
        treeData: navTreeData,
        path: rowInfo.path,
        getNodeKey,
        newNode: { ...rowInfo.node, [key]: value }
    });

    return data;
};
// To Remove Tree Node (Folder/File)
export const deleteNode = (rowInfo, navTreeData) => {
    const data = removeNodeAtPath({
        treeData: navTreeData,
        path: rowInfo.path,
        getNodeKey
    });

    return data;
};
// To Update Tree Node (Folder/File) title
export const updateTitle = (rowInfo, navTreeData, updateTreeDataFn, updateFolderName, resetTablePagination, drawerToggle) => {
    const handleLinkClick = () => {
        if (resetTablePagination) {
            resetTablePagination();
        }
        // Close drawer on mobile when link is clicked
        if (drawerToggle && window.innerWidth < 900) {
            drawerToggle();
        }
    };

    return rowInfo.node.edit ? (
        <>
            <input
                style={{ fontSize: '1.1rem', width: '100px' }}
                onBlur={(event) => {
                    const inputValue = event.target.value;
                    const name = inputValue.trim();
                    name.length > 0
                        ? updateTreeDataFn(changeNode(navTreeData, rowInfo, 'title', name))
                        : updateTreeDataFn(deleteNode(rowInfo, navTreeData));
                }}
            />
            <CheckIcon
                onClick={() => {
                    if (rowInfo.node.title) {
                        updateFolderName(changeNode(navTreeData, rowInfo, 'edit', false), true);
                    }
                }}
            />
            {rowInfo.node.removeCancelButton ? null : (
                <CancelIcon onClick={() => updateTreeDataFn(deleteNode(rowInfo, navTreeData), true)} />
            )}
        </>
    ) : (
        <>{rowInfo.node.isDirectory ? rowInfo.node.title : <NavTreeLink node={rowInfo.node} onClick={handleLinkClick} />}</>
    );
};

// To Update Tree Node (Folder/File) pre icon
// Todo OOnly works with Theme \ Currently theme has Some error
export const updateIcon = (rowInfo) => (rowInfo.node.isDirectory ? [] : [<CreateNewFolderIcon />]);
